import Form, {
  formCreate,
} from '@/found/components/form';
import request from '@/found/utils/request';
import CustomInput from './components/custom_input.vue';

formCreate.component('CustomInput', CustomInput);
export default {
  extends: Form,
  components: {
    formCreate: formCreate.$form(),
  },
  data() {
    return {
      rule: [],
      formFunctionCode: 'main_form',
      formParentCode: 'CRM20261009000000003',
      costRulesTierList: [],
      customRangeIndex: 0,
      fzRangeRule: null,
      whitelistRangeRule: null,
    };
  },

  methods: {
    // 设置规则
    setRule(item) {
      const v = item;

      // 统计周期，预警阈值
      if (v.field === 'ruleDay' || v.field === 'ruleBox') {
        v.props = {
          ...v.props,
          min: 1,
          precision: 0,
        };
      }

      // 短信告知周期
      if (v.field === 'smsDay') {
        v.props = {
          ...v.props,
          min: 0,
          precision: 0,
        };
      }

      // 预警告知对象
      if (v.field === 'notifyList') {
        v.props = {
          ...v.props,
          value: [],
          params: {
            functionCode: 'position_level_list',
            idKey: 'positionLevelCode',
            nameKey: 'positionLevelName',
            paramData: {
              enableStatus: '009',
            },
          },
          getValue: (field) => this.getFieldValue(field),
        };
      }
      // 分公司统计范围
      if (v.field === 'companyRangeList') {
        v.info = '不选则不过滤分公司维度，且终端扫码数据中，分公司为空的数据也统计';
        v.props = {
          ...v.props,
          value: [],
          params: {
            functionCode: 'company_list',
            idKey: 'orgCode',
            nameKey: 'orgName',
            paramData: {
              enableStatus: '009',
              orgType: 'area',
            },
          },
        };
      }
      // 经销商统计范围
      if (v.field === 'customerRangeList') {
        v.info = '不选则不过滤经销商';
        v.props = {
          ...v.props,
          value: [],
          params: {
            functionCode: 'dealer_list',
            idKey: 'customerCode',
            nameKey: 'customerName',
            paramData: {
              enableStatus: '009',
            },
          },
        };
      }
      // 系列统计范围
      if (v.field === 'productLevelRangeList') {
        v.info = '不选则不过滤系列';
        v.props = {
          ...v.props,
          value: [],
          params: {
            functionCode: 'product_level_list',
            idKey: 'productLevelCode',
            nameKey: 'productLevelName',
            paramData: {
              enableStatus: '009',
            },
          },
        };
      }
      return item;
    },

    // 完成渲染
    formComplete() {
      const {
        code,
      } = this.formConfig;
      if (code !== 'add') {
        request.get('/cps/terminalScanIndicator/findById', {
          id: this.formConfig.row.id,
        }).then((res) => {
          if (res.success) {
            const {
              result,
            } = res;
            const data = {
              ...result,
            };
            // 详情返回的 notifyList 是 notifyCode/notifyName，组件回显依赖 businessCode/businessName，先转回来
            if (Array.isArray(data.notifyList)) {
              data.notifyList = data.notifyList.map((item) => ({
                businessCode: item.notifyCode,
                businessName: item.notifyName,
              }));
            }
            this.setValue(data);
          }
        });
      }
    },
    // 提交
    submit() {
      const formData = this.getFormData(); // 获取表单的值
      if (formData) {
        const params = {
          ...formData,
        };
        // 组件选值时行上已统一存为 businessCode/businessName；按 codeNameMap 转成最终提交键：
        // notifyList → notifyCode/notifyName，其余统计范围 → businessCode/businessName
        const codeNameMap = {
          notifyList: ['notifyCode', 'notifyName'],
          companyRangeList: ['businessCode', 'businessName'],
          customerRangeList: ['businessCode', 'businessName'],
          productLevelRangeList: ['businessCode', 'businessName'],
        };
        Object.keys(codeNameMap).forEach((field) => {
          if (Array.isArray(params[field])) {
            const [codeKey, nameKey] = codeNameMap[field];
            params[field] = params[field].map((item) => {
              const row = {
                ...item,
                [codeKey]: item.businessCode,
                [nameKey]: item.businessName,
              };
              if (codeKey !== 'businessCode') { // notifyList：去掉中间键，只留 notifyCode/notifyName
                delete row.businessCode;
                delete row.businessName;
              }
              return row;
            });
          }
        });
        // 默认新增
        const url = '/cps/terminalScanIndicator/create';
        console.log(params);
        request.post(url, params).then((res) => {
          if (res.success) {
            this.$message({
              type: 'success',
              message: '操作成功',
            });
            this.$emit('onClose');
            this.$emit('onGetList');
          }
        });
      }
    },
  },
};
